import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandProps {
    className?: string
}

export const BrandMark: FC<BrandProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            className={cn('size-8 shrink-0', className)}
        >
            <rect width='32' height='32' rx='9' className='fill-primary' />
            <path
                d='M16 9.5 18.5 13 27 11.5 20.5 17 18 17.5 16 23.5 14 17.5 11.5 17 5 11.5 13.5 13Z'
                fill='#ffffff'
                stroke='#ffffff'
                strokeWidth='1.2'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const Brand: FC<BrandProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('flex items-center gap-2.5', className)}>
            <BrandMark />

            <span className='font-heading text-lg font-bold tracking-tight text-white'>
                Kestrel
            </span>
        </span>
    )
}
